import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Se c'è un hash (es. #roadmap), prova a scorrere all'elemento
      const id = hash.replace('#', '');
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        // Ritenta dopo un breve ritardo per consentire il rendering della pagina
        const timer = setTimeout(() => {
          const el = document.getElementById(id);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 100);
        return () => clearTimeout(timer);
      }
    } else {
      // Altrimenti scorri in cima
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};